var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFactoring(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:rgba(255,255,255,0.5);opacity:0;}.b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-78 -228)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24,
    height: 24,
    transform: "translate(78 228)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(78 156.527)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.98 87.612)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M194.52,309.334v-.094c-.478-.005-.935-.031-1.376-.068a6.273,6.273,0,0,1-1,1.709,16.228,16.228,0,0,0,2.4.213Z",
    transform: "translate(-192.146 -309.173)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 80.205)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.25,170.7a5.215,5.215,0,0,0-3.543-3.9,5.29,5.29,0,0,0-1.532-.229,5.176,5.176,0,1,0,3.485,9,5.147,5.147,0,0,0,1.693-3.828A5.432,5.432,0,0,0,10.25,170.7Zm-5.075.348a1.96,1.96,0,0,1,.53,3.849v.457a.519.519,0,1,1-1.039,0V174.9a1.973,1.973,0,0,1-1.454-1.9.519.519,0,0,1,1.039,0,.922.922,0,1,0,.919-.925,1.96,1.96,0,0,1-.5-3.854v-.223a.519.519,0,1,1,1.039,0v.234a1.964,1.964,0,0,1,1.428,1.891.519.519,0,1,1-1.039,0,.925.925,0,1,0-.925.919Z",
    transform: "translate(0 -166.573)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.274 84.76)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M218.111,256.148l-.031-1.839c-.322-.005-.639-.016-.94-.036.016.208.026.41.026.613a6.385,6.385,0,0,1-.119,1.215C217.389,256.133,217.747,256.148,218.111,256.148Z",
    transform: "translate(-217.046 -254.273)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.357 78.039)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M152.315,124.873a6.229,6.229,0,0,1-1.127.452,17.161,17.161,0,0,1-8.42.042,5.755,5.755,0,0,1-1.122-.431l.036,1.465a5.993,5.993,0,0,1,1.626.919c.016.005.026.005.042.01a14.861,14.861,0,0,0,3.537.39,14.7,14.7,0,0,0,4-.5c1.127-.343,1.376-.7,1.376-.769a.3.3,0,0,1,.052-.213Z",
    transform: "translate(-141.646 -124.873)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.305 75.473)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M149.933,75.977a14.5,14.5,0,0,0-4-.5,14.031,14.031,0,0,0-3.948.5c-1.1.332-1.335.66-1.34.764,0,0,.005,0,.005.01.026.114.338.467,1.454.79a14.262,14.262,0,0,0,3.828.467,14.678,14.678,0,0,0,3.994-.5c1.127-.338,1.382-.7,1.382-.769S151.061,76.32,149.933,75.977Z",
    transform: "translate(-140.646 -75.473)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.414 88.791)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M268.822,333.431v-1.558a6.663,6.663,0,0,1-1.091.442,15.361,15.361,0,0,1-4.29.545,15.987,15.987,0,0,1-3.9-.447,6.771,6.771,0,0,1-1.293-.473l.026,1.506v.01c0,.078.229.426,1.325.764a14.135,14.135,0,0,0,3.942.493,13.867,13.867,0,0,0,3.953-.509c1.1-.343,1.335-.7,1.335-.774Z",
    transform: "translate(-258.246 -331.873)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.235 80.937)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M204.827,180.673a6.56,6.56,0,0,1-1.122.447,15.5,15.5,0,0,1-4.306.545,18.707,18.707,0,0,1-2.353-.151,6.158,6.158,0,0,1,.93,1.932c.447.031.93.052,1.428.052h.052c.852-.935,3.143-1.4,5.371-1.465v-1.361Z",
    transform: "translate(-197.046 -180.673)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.367 85.919)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M266.841,277.015a15.547,15.547,0,0,1-4.244.53,15.353,15.353,0,0,1-4.119-.5,6.379,6.379,0,0,1-1.132-.436l.021,1.195.005.436c.405.5,2.343,1.153,5.22,1.153a14.372,14.372,0,0,0,3.984-.5c1.122-.343,1.366-.7,1.366-.769,0-.057.031-.119.031-.171h.005v-1.376A5.928,5.928,0,0,1,266.841,277.015Z",
    transform: "translate(-257.346 -276.573)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.331 83.348)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M265.933,227.566a14.557,14.557,0,0,0-4-.493h-.088a14.137,14.137,0,0,0-3.7.442c-1.075.3-1.444.644-1.491.784a.039.039,0,0,0-.005.021l.01.021c.031.109.338.462,1.454.79a16.143,16.143,0,0,0,7.776-.026c1.153-.343,1.413-.7,1.418-.779v-.005C267.3,228.242,267.04,227.9,265.933,227.566Z",
    transform: "translate(-256.646 -227.073)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactoring);
export default __webpack_public_path__ + "static/media/factoring.b0589fa64948ad24ddc8a85c2b1249d7.svg";
export { ForwardRef as ReactComponent };